import { useSelector } from 'react-redux';
import { has, isNil } from 'lodash';
import { getResourceApiKeys } from 'js/lib/ResourceUtils';
import { ApiKeysMap } from '@nexla/@types';

type Params = {
  dataSource: Record<string, any>;
  sourceBeingEdited: Record<string, any>;
};

export function useIncomingWebhookConfiguration(params: Params) {
  const { dataSource, sourceBeingEdited } = params;
  const apiKeys = useSelector((s: any) => s.entities.apiKeys);

  const source =
    !isNil(dataSource) && has(dataSource, 'id')
      ? dataSource
      : !isNil(sourceBeingEdited) && has(sourceBeingEdited, 'id')
        ? sourceBeingEdited
        : null;

  const sourceApiKeys = !isNil(source) ? getResourceApiKeys(source, apiKeys) : null;

  return {
    apiKeys: sourceApiKeys as ApiKeysMap,
  };
}
